<template>
  <div>
    <div class="background-height pb-1 background">
      <b-container fluid class="position-relative">
        <b-img
          src="https://res.cloudinary.com/oredev/image/upload/v1715163928/2024/Two-blobs-yellow.gif"
          fluid
          class="blob-mobile"
        ></b-img>

        <b-img
          src="https://res.cloudinary.com/oredev/image/upload/v1715163928/2024/Two-blobs-yellow.gif"
          fluid
          class="blob-left"
        ></b-img>

        <b-img
          src="https://res.cloudinary.com/oredev/image/upload/v1715163929/2024/two-blobs.gif"
          fluid
          class="blob-right"
        ></b-img>

        <div class="bg-desktop text-center">
          <b-img
            class=""
            style="width: 80%"
            fluid
            src="https://res.cloudinary.com/oredev/image/upload/v1715929291/2024/program_Asset_desktop.png"
          ></b-img>
        </div>

        <div class="bg-mobile my-2"></div>
        <b-row class="py-4 text-section">
          <b-col
            cols="12"
            class="justify-content-center flex-wrap py-3 d-none d-sm-block"
          >
            <h1 class="headline1 d-none d-sm-block">This year’s program</h1>
            <p class="text-dark w-100 text-center d-none d-sm-block">
              Discover the latest software trends explained by industry experts.
            </p>
          </b-col>

          <b-col cols="10" class="d-block d-sm-none">
            <h1 class="headline1 text-left">This year’s program</h1>
            <p class="text-dark w-100 text-left">
              Discover the latest software trends explained by industry experts.
            </p>
          </b-col>

          <b-img
            fluid
            class="headline-animation"
            src="https://res.cloudinary.com/oredev/image/upload/v1716374501/2024/blob-triangle_copy.gif"
          ></b-img>
          <b-img
            fluid
            class="d-block d-sm-none"
            style="
              position: absolute;
              width: 15%;
              right: 4%;
              top: 81%;
              rotate: 180deg;
            "
            src="https://res.cloudinary.com/oredev/image/upload/v1716374501/2024/blob-triangle_copy.gif"
          ></b-img>
        </b-row>
      </b-container>
    </div>
    <b-container fluid class="mt-5">
      <b-row>
        <b-col cols="12">
          <iframe
            class="w-100 iframe"
            src="https://sessionize.com/api/v2/riuoiat7/view/GridSmart"
            frameborder="0"
          ></iframe>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  name: "program",

  data() {
    return {
      isVisible: true,
      doctitle: "About Øredev - " + this.$store.state.conferencename,
    };
  },
  methods: {
    visibilityChanged(isVisible, entry) {
      this.isVisible = isVisible;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/variables.scss";

.iframe {
  height: 200vw;
  @media (min-width: 767px) {
    height: 100vw;
  }
  @media (min-width: 1000px) {
    height: 80vw;
  }
  /* @media (min-width: 349px) {
    height: 5850px;
  }
  @media (min-width: 399px) {
    height: 5650px;
  }
  @media (min-width: 599px) {
    height: 5300px;
  }
  @media (min-width: 999px) {
    height: 2150px;
  } 
  @media (min-width: 1199px) {
    height: 2000px;
  }
  @media (min-width: 1399px) {
    height: 1850px;
  }
  @media (min-width: 1799px) {
    height: 1700px;
  }
  @media (min-width: 1999px) {
    height: 1700px;
  } */
}

.bg-desktop {
  display: none;
}

@media only screen and (min-width: 600px) {
  .bg-desktop {
    display: flex;
    justify-content: center;
  }
}

.bg-mobile {
  background-image: url("https://res.cloudinary.com/oredev/image/upload/v1715929290/2024/program_Asset_mobile.png");
  background-size: contain;
  height: 70vh;
  background-position: center;
  background-repeat: no-repeat;
  display: block;
}

@media only screen and (min-width: 601px) {
  .bg-mobile {
    display: none;
  }
}

.text-section {
  background: rgba(239, 237, 234, 1);
}

.blob-right {
  display: none;
  position: absolute;
  width: 5%;
  top: 51%;
  right: 4%;
}
.blob-left {
  display: none;
  position: absolute;
  width: 5%;
  top: 4%;
  left: 9%;
}
.blob-mobile {
  display: block;
  position: absolute;
  width: 32%;
  top: 4%;
  right: 1%;
  bottom: 56%;
}

.bg-desktop {
  display: none;
}

.headline-animation {
  position: absolute;
  left: 10%;
  display: none;
}

@media only screen and (min-width: 600px) {
  .bg-desktop {
    display: block;
  }
  .blob-right {
    display: block;
  }
  .blob-left {
    display: block;
  }
  .blob-mobile {
    display: none;
  }
}

.headline-animation {
  @media only screen and (min-width: 1000px) {
    left: 5%;
    display: block;
  }
  @media only screen and (min-width: 1200px) {
    left: 10%;
  }
  @media only screen and (min-width: 1500px) {
    left: 15%;
  }
  @media only screen and (min-width: 1700px) {
    left: 20%;
  }
  @media only screen and (min-width: 2000px) {
    left: 25%;
  }
}

.headline1 {
  font-family: Outfit;
  font-size: 3rem;
  font-weight: 900 !important;
  line-height: 60.48px;
  letter-spacing: 0.05em;
  text-align: center;
  text-transform: uppercase;
}
</style>



// WEBPACK FOOTER //
// src/views/Program.vue